import { render, staticRenderFns } from "./FlavorSelect.vue?vue&type=template&id=c7c3770c&scoped=true&"
import script from "./FlavorSelect.vue?vue&type=script&lang=js&"
export * from "./FlavorSelect.vue?vue&type=script&lang=js&"
import style0 from "./FlavorSelect.vue?vue&type=style&index=0&id=c7c3770c&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7c3770c",
  null
  
)

export default component.exports